"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._getFrenDelegationBribesByBLS = exports._getGateKeeperAddress = exports._updateSyndicateActivationDistanceInBlocks = exports._recoverSigningKey = exports._transferSmartWalletOwnership = exports._getNetworkFeeRecipient = exports._mintDerivatives = exports._stake = exports._registerBLSPublicKeys = exports._claimRewardsAsNodeRunner = exports._withdrawETHForKnot = exports._rotateEOARepresentative = exports._updateNodeRunnerWhitelistStatus = exports._updateWhitelisting = exports._toggleHouseGatekeeper = exports._updateStakehouseTicker = exports._updateDaoRevenueCommission = exports._updateDaoAddress = exports._deRegisterKnotsFromSyndicate = exports._isBLSPublicKeyBanned = exports._getDaoCommissionPercentage = exports._getNumberOfKnots = exports._isNodeRunnerBanned = exports._getSmartWalletDormantRepresentative = exports._getStakedKnotsOfSmartWallet = exports._getNodeRunnerOfSmartWallet = exports._getSmartWalletOfNodeRunner = exports._getSmartWalletOfKnot = exports._getSmartWalletRepresentative = exports._isNodeRunnerWhitelisted = exports._isWhitelistingEnabled = exports._getStakehouseTicker = exports._getFeesAndMEVPoolAddress = exports._getSavETHVaultAddress = exports._getDAOAddress = exports._remove0x = exports._add0x = void 0;
const constants_1 = require("./constants");
const contracts_1 = require("./contracts");
const lodash_1 = __importDefault(require("lodash"));
const _add0x = (data) => {
    if (!data) {
        throw constants_1.customErrors.NULL_OR_UNDEFINED_VALUE;
    }
    if (lodash_1.default.isString(data)) {
        return (data.indexOf('0x') !== -1) ? data : '0x'.concat(data);
    }
    return data;
};
exports._add0x = _add0x;
const _remove0x = (data) => {
    if (!data) {
        throw constants_1.customErrors.NULL_OR_UNDEFINED_VALUE;
    }
    if (lodash_1.default.isString(data)) {
        return (data.indexOf('0x') !== -1) ? data.slice(2) : data;
    }
    return data;
};
exports._remove0x = _remove0x;
const _getDAOAddress = (signer, liquidStakingManagerAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.dao();
});
exports._getDAOAddress = _getDAOAddress;
const _getSavETHVaultAddress = (signer, liquidStakingManagerAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.savETHVault();
});
exports._getSavETHVaultAddress = _getSavETHVaultAddress;
const _getFeesAndMEVPoolAddress = (signer, liquidStakingManagerAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.stakingFundsVault();
});
exports._getFeesAndMEVPoolAddress = _getFeesAndMEVPoolAddress;
const _getStakehouseTicker = (signer, liquidStakingManagerAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.stakehouseTicker();
});
exports._getStakehouseTicker = _getStakehouseTicker;
const _isWhitelistingEnabled = (signer, liquidStakingManagerAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.enableWhitelisting();
});
exports._isWhitelistingEnabled = _isWhitelistingEnabled;
const _isNodeRunnerWhitelisted = (signer, liquidStakingManagerAddress, nodeRunnerAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.isNodeRunnerWhitelisted((0, exports._add0x)(nodeRunnerAddress));
});
exports._isNodeRunnerWhitelisted = _isNodeRunnerWhitelisted;
const _getSmartWalletRepresentative = (signer, liquidStakingManagerAddress, smartWalletAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.smartWalletRepresentative((0, exports._add0x)(smartWalletAddress));
});
exports._getSmartWalletRepresentative = _getSmartWalletRepresentative;
const _getSmartWalletOfKnot = (signer, liquidStakingManagerAddress, blsPublicKey) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.smartWalletOfKnot((0, exports._add0x)(blsPublicKey));
});
exports._getSmartWalletOfKnot = _getSmartWalletOfKnot;
const _getSmartWalletOfNodeRunner = (signer, liquidStakingManagerAddress, nodeRunnerAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.smartWalletOfNodeRunner((0, exports._add0x)(nodeRunnerAddress));
});
exports._getSmartWalletOfNodeRunner = _getSmartWalletOfNodeRunner;
const _getNodeRunnerOfSmartWallet = (signer, liquidStakingManagerAddress, smartWalletAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.nodeRunnerOfSmartWallet((0, exports._add0x)(smartWalletAddress));
});
exports._getNodeRunnerOfSmartWallet = _getNodeRunnerOfSmartWallet;
const _getStakedKnotsOfSmartWallet = (signer, liquidStakingManagerAddress, smartWalletAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.stakedKnotsOfSmartWallet((0, exports._add0x)(smartWalletAddress));
});
exports._getStakedKnotsOfSmartWallet = _getStakedKnotsOfSmartWallet;
const _getSmartWalletDormantRepresentative = (signer, liquidStakingManagerAddress, smartWalletAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.smartWalletDormantRepresentative((0, exports._add0x)(smartWalletAddress));
});
exports._getSmartWalletDormantRepresentative = _getSmartWalletDormantRepresentative;
const _isNodeRunnerBanned = (signer, liquidStakingManagerAddress, nodeRunnerAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.bannedNodeRunners((0, exports._add0x)(nodeRunnerAddress));
});
exports._isNodeRunnerBanned = _isNodeRunnerBanned;
const _getNumberOfKnots = (signer, liquidStakingManagerAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.numberOfKnots();
});
exports._getNumberOfKnots = _getNumberOfKnots;
const _getDaoCommissionPercentage = (signer, liquidStakingManagerAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.daoCommissionPercentage();
});
exports._getDaoCommissionPercentage = _getDaoCommissionPercentage;
const _isBLSPublicKeyBanned = (signer, liquidStakingManagerAddress, blsPublicKey) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.isBLSPublicKeyBanned((0, exports._add0x)(blsPublicKey));
});
exports._isBLSPublicKeyBanned = _isBLSPublicKeyBanned;
const _deRegisterKnotsFromSyndicate = (signer, liquidStakingManagerAddress, blsPublicKeys) => __awaiter(void 0, void 0, void 0, function* () {
    for (let i = 0; i < blsPublicKeys.length; ++i) {
        blsPublicKeys[i] = (0, exports._add0x)(blsPublicKeys[i]);
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.deRegisterKnotFromSyndicate(blsPublicKeys);
});
exports._deRegisterKnotsFromSyndicate = _deRegisterKnotsFromSyndicate;
const _updateDaoAddress = (signer, liquidStakingManagerAddress, newDaoAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.updateDAOAddress((0, exports._add0x)(newDaoAddress));
});
exports._updateDaoAddress = _updateDaoAddress;
const _updateDaoRevenueCommission = (signer, liquidStakingManagerAddress, newDaoRevenueCommission) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.updateDAORevenueCommission(newDaoRevenueCommission);
});
exports._updateDaoRevenueCommission = _updateDaoRevenueCommission;
const _updateStakehouseTicker = (signer, liquidStakingManagerAddress, newStakehouseTicker) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.updateTicker(newStakehouseTicker);
});
exports._updateStakehouseTicker = _updateStakehouseTicker;
const _toggleHouseGatekeeper = (signer, liquidStakingManagerAddress, enable) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.toggleHouseGatekeeper(enable);
});
exports._toggleHouseGatekeeper = _toggleHouseGatekeeper;
const _updateWhitelisting = (signer, liquidStakingManagerAddress, newWhitelistingStatus) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.updateWhitelisting(newWhitelistingStatus);
});
exports._updateWhitelisting = _updateWhitelisting;
const _updateNodeRunnerWhitelistStatus = (signer, liquidStakingManagerAddress, nodeRunnerAddresses, newWhitelistingStatus) => __awaiter(void 0, void 0, void 0, function* () {
    for (let i = 0; i < nodeRunnerAddresses.length; ++i) {
        nodeRunnerAddresses[i] = (0, exports._add0x)(nodeRunnerAddresses[i]);
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.updateNodeRunnerWhitelistStatus(nodeRunnerAddresses, newWhitelistingStatus);
});
exports._updateNodeRunnerWhitelistStatus = _updateNodeRunnerWhitelistStatus;
const _rotateEOARepresentative = (signer, liquidStakingManagerAddress, newRepresentativeAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.rotateEOARepresentative((0, exports._add0x)(newRepresentativeAddress));
});
exports._rotateEOARepresentative = _rotateEOARepresentative;
const _withdrawETHForKnot = (signer, liquidStakingManagerAddress, recipientAddress, blsPublicKey) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.withdrawETHForKnot((0, exports._add0x)(recipientAddress), (0, exports._add0x)(blsPublicKey));
});
exports._withdrawETHForKnot = _withdrawETHForKnot;
const _claimRewardsAsNodeRunner = (signer, liquidStakingManagerAddress, recipientAddress, blsPublicKeys) => __awaiter(void 0, void 0, void 0, function* () {
    for (let i = 0; i < blsPublicKeys.length; ++i) {
        blsPublicKeys[i] = (0, exports._add0x)(blsPublicKeys[i]);
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.claimRewardsAsNodeRunner((0, exports._add0x)(recipientAddress), blsPublicKeys);
});
exports._claimRewardsAsNodeRunner = _claimRewardsAsNodeRunner;
const _registerBLSPublicKeys = (signer, liquidStakingManagerAddress, blsPublicKeys, blsSignatures, representativeAddress, ethValue) => __awaiter(void 0, void 0, void 0, function* () {
    if (blsPublicKeys.length != blsSignatures.length) {
        throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
    }
    for (let i = 0; i < blsPublicKeys.length; ++i) {
        blsPublicKeys[i] = (0, exports._add0x)(blsPublicKeys[i]);
        blsSignatures[i] = (0, exports._add0x)(blsSignatures[i]);
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.registerBLSPublicKeys(blsPublicKeys, blsSignatures, (0, exports._add0x)(representativeAddress), { value: ethValue });
});
exports._registerBLSPublicKeys = _registerBLSPublicKeys;
const _stake = (signer, liquidStakingManagerAddress, blsPublicKeys, cipherTexts, aesEncryptorKeys, encryptionSignatures, dataRoots) => __awaiter(void 0, void 0, void 0, function* () {
    const arrayLength = blsPublicKeys.length;
    if (arrayLength != cipherTexts.length || arrayLength != aesEncryptorKeys.length || arrayLength != encryptionSignatures.length || arrayLength != dataRoots.length) {
        throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
    }
    for (let i = 0; i < arrayLength; ++i) {
        blsPublicKeys[i] = (0, exports._add0x)(blsPublicKeys[i]);
        cipherTexts[i] = (0, exports._add0x)(cipherTexts[i]);
        aesEncryptorKeys[i] = (0, exports._add0x)(aesEncryptorKeys[i]);
        encryptionSignatures[i].r = (0, exports._add0x)(encryptionSignatures[i].r);
        encryptionSignatures[i].s = (0, exports._add0x)(encryptionSignatures[i].s);
        dataRoots[i] = (0, exports._add0x)(dataRoots[i]);
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.stake(blsPublicKeys, cipherTexts, aesEncryptorKeys, encryptionSignatures, dataRoots);
});
exports._stake = _stake;
const _mintDerivatives = (signer, liquidStakingManagerAddress, blsPublicKeys, beaconChainReports, authenticatedReportSignatures) => __awaiter(void 0, void 0, void 0, function* () {
    const arrayLength = blsPublicKeys.length;
    if (arrayLength != authenticatedReportSignatures.length || arrayLength != beaconChainReports.length || arrayLength != authenticatedReportSignatures.length) {
        throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
    }
    for (let i = 0; i < blsPublicKeys.length; ++i) {
        blsPublicKeys[i] = (0, exports._add0x)(blsPublicKeys[i]);
        authenticatedReportSignatures[i].r = (Buffer.from(authenticatedReportSignatures[i].r, 'hex')).toString();
        authenticatedReportSignatures[i].s = (Buffer.from(authenticatedReportSignatures[i].s, 'hex')).toString();
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.mintDerivatives(blsPublicKeys, beaconChainReports, authenticatedReportSignatures);
});
exports._mintDerivatives = _mintDerivatives;
const _getNetworkFeeRecipient = (signer, liquidStakingManagerAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.getNetworkFeeRecipient();
});
exports._getNetworkFeeRecipient = _getNetworkFeeRecipient;
const _transferSmartWalletOwnership = (signer, liquidStakingManagerAddress, newOwner) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.transferSmartWalletOwnership(newOwner);
});
exports._transferSmartWalletOwnership = _transferSmartWalletOwnership;
const _recoverSigningKey = (signer, liquidStakingManagerAddress, safeBoxAddress, nodeRunnerAddress, blsPublicKey, hAesPublicKey) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.recoverSigningKey((0, exports._add0x)(safeBoxAddress), (0, exports._add0x)(nodeRunnerAddress), (0, exports._add0x)(blsPublicKey), (0, exports._add0x)(hAesPublicKey));
});
exports._recoverSigningKey = _recoverSigningKey;
const _updateSyndicateActivationDistanceInBlocks = (signer, liquidStakingManagerAddress, distance) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.updateSyndicateActivationDistanceInBlocks(distance);
});
exports._updateSyndicateActivationDistanceInBlocks = _updateSyndicateActivationDistanceInBlocks;
const _getGateKeeperAddress = (signer, liquidStakingManagerAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).liquidStakingManager(liquidStakingManagerAddress);
    return contract.gatekeeper();
});
exports._getGateKeeperAddress = _getGateKeeperAddress;
const _getFrenDelegationBribesByBLS = (signer, bribeVaultAddress, blsKey) => __awaiter(void 0, void 0, void 0, function* () {
    if (!blsKey) {
        throw constants_1.customErrors.NULL_OR_UNDEFINED_VALUE;
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).frenDelegationBribeVault(bribeVaultAddress);
    const bribeDepositData = yield contract.deposits((0, exports._add0x)(blsKey));
    const erc20Contract = (yield (0, contracts_1.getContractInstance)(signer)).erc20((0, exports._add0x)(bribeDepositData.token));
    const bribeTokenSymbol = yield erc20Contract.symbol();
    const bribeTokenDecimals = yield erc20Contract.decimals();
    const newBribeData = {
        id: bribeDepositData.id,
        token: bribeDepositData.token,
        tokenAmount: bribeDepositData.tokenAmount,
        tokenToEthRatio: bribeDepositData.tokenToEthRatio,
        expiration: bribeDepositData.expiration,
        snapshot: bribeDepositData.snapshot,
        tokenName: bribeTokenSymbol,
        tokenDecimals: bribeTokenDecimals
    };
    return newBribeData;
});
exports._getFrenDelegationBribesByBLS = _getFrenDelegationBribesByBLS;
